export const errorCodes = {
  UserAccountExists: 'User with entered email already exists',
};
